import { render, staticRenderFns } from "./ShortArticleReport.vue?vue&type=template&id=77f065f4&"
import script from "./ShortArticleReport.vue?vue&type=script&lang=js&"
export * from "./ShortArticleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports